import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.main`
  flex: 1;
  overflow-y: auto;
`;

export const MobileHeader = styled.header`
  background: #01579b;
  color: #fff;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 4px;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  div {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export const MobileFooter = styled.footer`
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 8px;
  display: flex;
  justify-content: space-around;

  button {
    background: transparent;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #01579b;
    padding: 6px 12px;
    border-radius: 4px;
    transition: background-color 0.2s;

    span {
      font-size: 12px;
      margin-top: 4px;
    }

    &:active {
      background: ${shade(0.1, '#f5f5f5')};
    }
  }
`;
